import LabelCreator from "../../output/labels/labels/label-creator.js";

class DomLabelCreator {
    create() {
        const domElement = document.createElement("div");

        Object.assign(domElement.style, {
            position: "absolute",
            pointerEvents: "none",
            color: "#ffffff",
            transform: "translate(-50%, -50%)",
            textShadow: "#000000 -1px 0, #000000 1px 0, #000000 0 -1px, #000000 0 1px",
        });

        const label = { domElement };
        return label;
    }

    dispose(label) {}
}

export default DomLabelCreator;
